import {combineReducers} from "redux";
import photos from "./photos.reducer.js";

const reducer = combineReducers({photos});

export default reducer;
